export const HOURS_DEFAULT_MOR_FROM = "08:00"
export const HOURS_DEFAULT_MOR_TO = "14:00"
export const HOURS_DEFAULT_AFT_FROM = "14:00"
export const HOURS_DEFAULT_AFT_TO = "18:00"